import React from "react";
import { formatIntegrants } from "../utils/garrison-audit-utils";

const CompositionContent = ({composition, isUpdate = false}) => {
    if (!composition) return null;

    const valueCellClassName = "whitespace-normal break-all";
    const rows = [];
    Object.entries(composition).forEach(([key, item]) => {

        const integrants = formatIntegrants(item?.compositiongarrison_integrants);

        if (item?.compositiongarrison_name) {
            rows.push(
                <tr key={`${key}-name`}>
                    <td>Nome</td>
                    <td className={valueCellClassName}>{item.compositiongarrison_name}</td>
                    {isUpdate && <td></td>}
                </tr>
            );
        }

        if (item?.compositiongarrison_initialmileage) {

            if (isUpdate) {
                rows.push(
                    <tr key={`${key}-initial`}>
                        <td>Km inicial</td>
                        <td className={valueCellClassName}>{item.compositiongarrison_initialmileage?.new ?? ""}</td>
                        <td className={valueCellClassName}>{item.compositiongarrison_initialmileage?.old ?? ""}</td>
                    </tr>
                );
            } else {
                rows.push(
                    <tr key={`${key}-initial`}>
                        <td>Km inicial</td>
                        <td className={valueCellClassName}>{item.compositiongarrison_initialmileage}</td>
                    </tr>
                );
            }
        }

        if (item?.compositiongarrison_finalmileage) {

            if (isUpdate) {
                rows.push(
                    <tr key={`${key}-final`}>
                        <td>Km final</td>
                        <td className={valueCellClassName}>{item.compositiongarrison_finalmileage?.new ?? ""}</td>
                        <td className={valueCellClassName}>{item.compositiongarrison_finalmileage?.old ?? ""}</td>
                    </tr>
                );
            } else {
                rows.push(
                    <tr key={`${key}-final`}>
                        <td>Km final</td>
                        <td className={valueCellClassName}>{item.compositiongarrison_finalmileage}</td>
                    </tr>
                );
            }
        }

        if (integrants) {
            rows.push(
                <tr key={`${key}-integrants`}>
                    <td>Contingentes</td>
                    <td className={valueCellClassName}>{integrants}</td>
                    {isUpdate && <td></td>}
                </tr>
            );
        }

    });

    if (!rows.length) return null;

    return (
        <>
            <tr>
                <th colSpan={isUpdate ? 3 : 2} className={'text-left'}>Composição</th>
            </tr>
            {rows}
        </>
    );
};

export default CompositionContent;
